module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_Spain.a9af5ae3.jpg";